import { AccordionButton, AccordionIcon, Box, Heading, Text } from "@chakra-ui/react";
import { t } from "i18next";
import * as React from "react";

function CustomAccordionButton({ headerText, isExpanded }) {
  return (
    <h2>
      <AccordionButton>
        <Box flex="1" textAlign="left">
          <Heading as="h2" size="sm">
            {headerText}
          </Heading>
        </Box>
        <Text fontSize={"sm"} mr={2}>
          {isExpanded ? t("buttons.collapse") : t("buttons.expand")}
        </Text>
        <AccordionIcon />
      </AccordionButton>
    </h2>
  );
}

export default CustomAccordionButton;